export { default } from './ShipmentCRContentsTable'
